/**
 * i18n keys for the popular job search terms.
 * Shared between the header SearchJobSection dropdown and the sidebar popular searches.
 */
export const POPULAR_SEARCH_KEYS = [
  'popular.search.filters.driver',
  'popular.search.filters.engineer',
  'popular.search.filters.manager',
  'popular.search.filters.part.time',
  'popular.search.filters.sales',
  'popular.search.filters.remote',
  'popular.search.filters.marketing',
  'popular.search.filters.accountant',
  'popular.search.filters.abroad',
] as const;

export type PopularSearchKey = (typeof POPULAR_SEARCH_KEYS)[number];
